<template>
	<div class="progress-blocks progress-blocks--weeks" ref="progressBlockContainer">
		<div class="progress-blocks__row progress-blocks__row--weeks">
			<div
				@click="goToWeek(week, index)"
				:key="index"
				v-for="(week, index) in weeks"
				:class="{'progress-block--active':active === index}"
				ref="progressBlock"
				class="progress-block">
				<div class="progress-block__top">
					<h3 class="progress-block__top__title">Week {{week.week}}</h3>
					<!--<p v-if="getOpenTasks(week) > 0" class="progress-block__top__tasks">
						<span v-if="getOpenTasks(week) > 1">{{getOpenTasks(week)}} open tasks</span>
						<span v-else-if="getOpenTasks(week) === 1">1 open task</span>
					</p>-->
				</div>
				<BrickFooter :tasks="getWeekTasks(week, tasks)"></BrickFooter>
			</div>
		</div>
	</div>
</template>

<script>
import DateService from '@/services/DateService'
import PlanningService from '@/services/PlanningService'
import BrickFooter from '@/components/structure/BrickFooter'
export default {
	components: {
		BrickFooter
	},
	props: {
		plannings: Array
	},
	data () {
		return {
			active: 0
		}
	},
	methods: {
		setWeek (animate) {
			// See if week is specified
			if (!this.$route.params.date) {
				this.active = this.weeks.findIndex(week => week.date.setHours(0, 0, 0, 0) === DateService.getCurrentMonday(new Date()).setHours(0, 0, 0, 0))
			} else {
				this.active = this.weeks.findIndex(week => week.date.setHours(0, 0, 0, 0) === DateService.getCurrentMonday(new Date(this.$route.params.date)).setHours(0, 0, 0, 0))
			}
			const offset = this.$refs.progressBlock[this.active].offsetLeft
			const blockWidth = this.$refs.progressBlock[this.active].clientWidth
			const totalWidth = this.$refs.progressBlockContainer.clientWidth
			if (animate) this.scrollBlocks(offset - (0.5 * totalWidth) + (0.5 * blockWidth))
			else this.$refs.progressBlockContainer.scrollLeft = offset - (0.5 * totalWidth) + (0.5 * blockWidth)
		},
		goToWeek (week, index) {
			this.active = index
			this.$router.push('/week/' + week.date.format('Y-m-d'))
		},
		scrollBlocks (offset, duration = 500) {
			const start = this.$refs.progressBlockContainer.scrollLeft
			const change = offset - start
			const increment = 10
			let currentTime = 0
			Math.easeInOutQuad = function (t, b, c, d) {
				t /= d / 2
				if (t < 1) return c / 2 * t * t + b
				t--
				return -c / 2 * (t * (t - 2) - 1) + b
			}
			// Animate function to be called repetitevely
			const animateScroll = () => {
				currentTime += increment
				const val = Math.easeInOutQuad(currentTime, start, change, duration)
				this.$refs.progressBlockContainer.scrollLeft = val
				if (currentTime < duration) setTimeout(animateScroll, increment)
			}
			animateScroll()
		},
		getWeekTasks (week, tasks) {
			return PlanningService.getWeekTasks(week, tasks)
		},
		getOpenTasks (week) {
			return 2
		}
	},
	computed: {
		tasks () {
			var tasks = []
			this.plannings.forEach(planning => {
				tasks = tasks.concat(planning.Tasks)
			})
			return tasks
		},
		weeks () {
			return DateService.getTaskWeeks(this.tasks)
		}
	},
	watch: {
		'$route' () {
			this.setWeek(true)
		}
	},
	mounted () {
		this.setWeek(false)
	}
}
</script>

<style lang="scss" scoped>
@import "@/styles/components/_progress-blocks.scss";
.progress-block__top {
	&__title {
		display: inline-block;
		vertical-align: middle;
	}
	&__tasks {
		@extend %label;
		@extend %label--secondary;
		display: inline-block;
		vertical-align: middle;
	}
}
</style>
